"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _icons = require("./icons");
const SelectedItems = _ref => {
  let {
    items,
    itemToString,
    getRemoveButtonProps,
    disabled
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _map.default)(items).call(items, item => /*#__PURE__*/_react.default.createElement(_styles.SelectedItem, {
    key: itemToString(item),
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_icons.RemoveItemIcon, (0, _extends2.default)({
    title: "Remove"
  }, getRemoveButtonProps({
    item,
    disabled
  }))), itemToString(item))));
};
var _default = exports.default = SelectedItems;
SelectedItems.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SelectedItems"
};